import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import axios from 'axios';
import APIDomain from './apiSettings';
import * as Realm from 'realm-web';

const APP_ID = process.env.REACT_APP_MONGO_GRAPH_QL_APP_ID || '';

// Connect to your MongoDB Realm app
const app = new Realm.App(APP_ID);

async function getValidAccessToken() {
  if (!app.currentUser) {
    await app.logIn(Realm.Credentials.anonymous());
  } else {
    await app.currentUser.refreshCustomData();
  }
  return app.currentUser?.accessToken;
}

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: process.env.REACT_APP_MONGO_GRAPH_QL_URL,
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
    },
    fetch: async (uri, options) => {
      const token = await getValidAccessToken();
      const headers = new Headers(options?.headers);
      headers.set('Authorization', `Bearer ${token}`);
      options.headers = headers;
      return fetch(uri, options);
    },
  }),
});

axios.defaults.baseURL = APIDomain;

export const getBaseClient = () => axios.create({ baseURL: APIDomain });
